import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';

function baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
}
function uploadFile({ id, file, filename, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const uploadUrl = yield this.request('/zambda/{id}/s3-upload', 'post', baseUrlThunk.bind(this))({ id, filename });
        yield fetch(uploadUrl.signedUrl, {
            method: 'PUT',
            body: file,
        });
    });
}

export { uploadFile };
//# sourceMappingURL=zambda-ext.js.map
